import {
    createApiClient
} from '.';
import type {
 AxiosInstance
} from 'axios';

// Notice since we don't have a production environment, we are using the staging environment as the production environment
const BEXO_API_BASE_URL: string = process.env.REACT_APP_BEXO_URL || '';
// const BEXO_API_BASE_URL = 'https://stg-bex.coolriots.ai'
const BEXO_API_ENDPOINT_PREFIX = '/bexo';

/**
 * HTTP client for the BEXO  API endpoints /  services.
 *
 * @type {ApiClient}
 * @see {@link https://github.com/coolriots/BeXOrchestrator}
 */
const bexoHttpClient: AxiosInstance = createApiClient(
    BEXO_API_BASE_URL,
    BEXO_API_ENDPOINT_PREFIX

);
// FB-021: the apps endpoint is now served by bex-server (/bexo/api/v1/
// applications) behind verifyJWT, which reads the `user-session` cookie —
// so this client MUST send credentials (every other platform client does;
// only this one had opted out, which 401'd the App Builder).
bexoHttpClient.defaults.withCredentials = true;
export {bexoHttpClient};
